import React from 'react';
import { View, Image } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import styles from './DeviceCard.Styles';

const DeviceCard = ({
  brand,
  name,
  image,
  price,
  onSelectDevicePress,
  containerStyle,
  isSelectedDevice,
  ...prop
}) => {
  const theme = useTheme();
  const { upfront, currency, recurringCharge } = price;
  const { currencyTransformer } = DateCurrencyFromatter.dateCurrencyFromatter;

  return (
    <View style={[styles.containerStyle(theme), containerStyle]}>
      <Image source={image} style={styles.imageStyle} resizeMode="contain" />

      <VFText i18nKey={brand} style={styles.brandTextStyle} type="primary" />
      <VFText i18nKey={name} style={styles.nameTextStyle} type="primary" />

      <VFText style={styles.priceTextStyle}>
        <VFText i18nKey="device_upgrade_choose_step_price_from" type="primary" />
        <VFText i18nKey="   " localize={false} />
        <VFText
          i18nKey={upfront && +currencyTransformer(upfront, 0)}
          localize={false}
          style={styles.priceValueTextStyle}
          type="primary"
        />
        <VFText i18nKey={currency} style={styles.priceValueTextStyle} type="primary" />
        <VFText i18nKey=" " localize={false} />
        <VFText i18nKey="device_upgrade_choose_step_price_upfront" type="primary" />
        <VFText i18nKey="   " localize={false} />
        <VFText
          i18nKey={recurringCharge && +currencyTransformer(recurringCharge, 0)}
          localize={false}
          style={styles.priceValueTextStyle}
          type="primary"
        />
        <VFText i18nKey={currency} style={styles.priceValueTextStyle} type="primary" />
        <VFText i18nKey="/" />
        <VFText i18nKey="device_upgrade_choose_step_price_per_month" type="primary" />
      </VFText>

      <VFButton
        title={
          isSelectedDevice
            ? 'device_upgrade_choose_step_selected'
            : 'device_upgrade_choose_step_cta_button_title'
        }
        type={isSelectedDevice ? 'quaternary' : 'tertiary'}
        onPress={onSelectDevicePress}
      />
    </View>
  );
};

DeviceCard.defaultProps = {
  price: {},
};

DeviceCard.propTypes = {
  brand: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  image: PropTypes.shape({ uri: PropTypes.string.isRequired }).isRequired,
  price: PropTypes.shape({
    upfront: PropTypes.number,
    currency: PropTypes.string,
    recurringCharge: PropTypes.number,
  }).isRequired,
  onSelectDevicePress: PropTypes.func.isRequired,
  containerStyle: ViewPropTypes.style,
  isSelectedDevice: PropTypes.bool,
};

export default DeviceCard;
